<div class="sub-header" [ngClass]="{ scrolled: currentScroll != 0 }">
  <button mat-icon-button class="go-back" (click)="goBack()">
    <mat-icon>arrow_back</mat-icon>
  </button>
</div>
